import styled from 'styled-components';

export const TalkingBubble = styled.path`
  color: ${({ theme }) => theme.colors.accent};
`;

export const TalkingBubbleLineDetail = styled.path`
  color: ${({ theme }) => theme.colors.primary};
`;
